import React, { Component } from "react";
import AuthService from "../../session/AuthService";
import ManageUserService from "../../api/ManageUserService";
import { Button, Form } from "react-bootstrap";
import { Toaster, toast } from "react-hot-toast";




class ProfileContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      male: false,
      female: false,
      formValues: {},
    };
  }

  componentDidMount = () => {
    let data = AuthService.getUserdata();

    let obj = {
      id: data.uId,
    };

    ManageUserService.getAdminloginValue(obj).then((response) => {
      console.log("response", response);

      let form = { ...response.data.data.userDetail };

      if (form.hasOwnProperty("phone_no")) {
        form.phoneNo = form.phone_no;
        delete form.phone_no;
      }

      let male = null;
      let female = null;

      if (response.data.data.userDetail.gender === "male") {
        male = true;
        female = false;
      } else if (response.data.data.userDetail.gender === "female") {
        female = true;
        male = false;
      } else {
        male = false;
        female = false;
      }




      this.setState(
        {
          formValues: form,
          male : male ,
          female : female

        },
        () => {
          console.log("userData in component", this.state.userData);
        }
      );
    });
  };

  render() {
    console.log("this.state in formEdit", this.state.formValues);
    const { formValues } = this.state;
    return (
      <>
        <div
          className="allign-the-form"
          style={{
            paddingLeft: "100px",
            paddingRight: "100px",
            paddingTop: "100px",
          }}
        >
          <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
            <Form.Label> First Name</Form.Label>
            <Form.Control
              type="text"
              placeholder="First Name"
              autoFocus
              className="small-input"
              name="firstName"
              value={formValues.firstName}
              onChange={this.onChangeformValues}
            />
          </Form.Group>
          <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
            <Form.Label>Last Name</Form.Label>
            <Form.Control
              type="text"
              placeholder="Last Name"
              autoFocus
              className="small-input"
              name="lastName"
              value={formValues.lastName}
              onChange={this.onChangeformValues}
            />
          </Form.Group>
          <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
            <Form.Label>Email</Form.Label>
            <Form.Control
              type="email"
              placeholder="Email"
              autoFocus
              className="small-input"
              name="mailID"
               
              value={formValues.mailID}
              onChange={this.onChangeformValues}
            />
          </Form.Group>

          <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
            <Form.Label>Phone Number</Form.Label>
            <Form.Control
              type="text"
              placeholder="Phone Number"
              autoFocus
              className="small-input"
              name="phoneNo"
              value={formValues.phoneNo}
              onChange={this.onChangeformValues}
            />
          </Form.Group>

        
          <div className="col" style={{ marginBottom: "9px" }}>
            <label style={{ fontWeight: "400" }} className="">
              {("Gender")}
            </label>
            <div>
              <div style={{ display: "inline-block", marginRight: "10px" }}>
                <label className="">Male</label>
                <input
                  type="radio"
                  id="option1"
                  name="male"
                  checked={this.state.male}
                   
                  onClick={(e) => this.handlechangechecked(e)}
                />
              </div>

              <div style={{ display: "inline-block" }}>
                <label className="">Female</label>
                <input
                  type="radio"
                  id="option2"
                  name="female"
                  checked={this.state.female}
                
                  onClick={(e) => this.handlechangechecked2(e)}
                />
              </div>
            </div>
          </div>

          <Button
            variant="success"
            type="button"
            id="formbutton-edit"
            onClick={this.saveEmployee}
          >
            Update Profile
          </Button>

        </div>
        <Toaster />
      </>
    );
  }

  
  handlechangechecked2 = () => {
    this.setState({
      female: !this.state.female,
      male: false,
    },() => {
      console.log("female" , this.state.female)
    });
  };


  handlechangechecked = () => {
    this.setState({
      male: !this.state.male,
      female: false,
    },() => {
      console.log("male" , this.state.male)
    });
  };


  onChangeformValues = (event) => {
    
    let form = { ...this.state.formValues };

    form[event.target.name] = event.target.value;

    this.setState(
      {
        formValues: form,
      },
      () => {
        console.log("formValue", this.state.formValues);
      }
    );
  };

  saveEmployee = () => {

    if(!this.state.formValues.firstName){
      toast.error("Please enter the First Name");
    }else if (!this.state.formValues.lastName){
      toast.error("Please enter the Last Name");
    }else if (!this.state.formValues.mailID) {
      toast.error("Please Enter Email");
    } else if (!/\S+@\S+\.\S+/.test(this.state.formValues.mailID)) {
      toast.error("Please Enter a Valid Email");
    }else {
      let form = { ...this.state.formValues };

      // Check if the 'mailID' key exists and rename it to 'email'
      if (form.hasOwnProperty("mailID")) {
        form.email = form.mailID;
        delete form.mailID;
      }
  
      let gender = ""
     if(this.state.male === true){
      gender = "male"
     }else if(this.state.female === true){
      gender = "female"
     }else {
      gender = ""
     }
     form["gender"] = gender
  
      ManageUserService.editAdmin(form).then((response) => {
        
        if(response.data && response.data.message === "Success"){
          toast.success("Profile Updated Successfully");
        }else if (response.data && response.data.message === "Mobile number already exists"){
          toast.error("Mobile number already exists");
        }else if (response.data && response.date.message === "Email address already exists"){
          toast.error("Email address already exists");
        }
  
       
      });
    }

   
  };
}
export default ProfileContainer;
